<template>
  <section class="overflow-hidden">
    <v-card class="card">
      <v-row no-gutters>
        <v-row justify="center" no-gutters>
          <v-row justify="center" no-gutters>
            <v-col cols="12" xs="12">
              <v-row justify="center">
                <h1 class="mt-7 mb-5 text-center">{{ $t("Github.Title") }}</h1>
              </v-row>
              <v-row justify="center">
                <v-card-subtitle class="mt-7 mb-5 text-center">{{
                  $t("Github.Subtitle")
                }}</v-card-subtitle>
              </v-row>
            </v-col>
          </v-row>
        </v-row>

        <v-row
          justify="center"
          align="center"
          v-if="apiState !== 3 || githubProjects == null"
        >
          <Loading />
        </v-row>

        <v-row v-if="apiState === 3" justify="center">
          <v-col
            cols="auto"
            v-for="(project, idx) in githubProjects"
            :key="idx"
          >
            <v-sheet
              color="transparent"
              width="50vw"
              max-width="800"
              class="pa-5 ma-5"
            >
              <v-row justify="center" align="center">
                <v-sheet
                  class="rounded-lg"
                  color="secondary"
                  width="100vw"
                  max-width="800"
                  data-aos="fade-up"
                  :elevation="18"
                >
                  <v-container>
                    <v-row justify="center">
                      <v-card-title
                        class="text-center font-weight-bold text-uppercase"
                        data-aos="fade-up"
                        >{{ project.name }}</v-card-title
                      >
                    </v-row>
                    <v-row>
                      <v-card-text
                        class="text-center font-italic text-capitalize"
                        >{{ project.description }}</v-card-text
                      >
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col cols="auto" xs="12">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :icon="true"
                              id="githubIconBtn"
                              x-large
                              v-bind="attrs"
                              v-on="on"
                              v-on:click="openGithubRepoUrl(project.name)"
                              :dark="darkMode"
                              data-aos="zoom-in"
                            >
                              <v-icon x-large>mdi-github</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("Github.OpenRepoTooltip") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <Milestones :milestonesData="project.commits" />
                    </v-row>
                    <v-row>
                      <Chart
                        :title="project.name"
                        :chartData="project.commits"
                      />
                    </v-row>
                  </v-container>
                </v-sheet>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
  </section>
</template>
<script>
import Loading from "./shared/Loading";
import Chart from "./visualization/Chart";
import Milestones from "./visualization/Milestones";

export default {
  name: "GitHub",
  data() {
    return {
      componentLoaded: false,
    };
  },
  components: {
    Chart,
    Loading,
    Milestones,
  },
  computed: {
    github() {
      return this.$store.getters["github/github"];
    },
    githubProjects() {
      if (!this.componentLoaded) {
        return null;
      }
      return this.$store.getters["github/githubProjects"];
    },
    apiState() {
      return this.$store.getters["github/apiState"];
    },
    darkMode() {
      return this.$store.getters["settings/darkMode"];
    },
  },
  methods: {
    openGithubRepoUrl(repo) {
      let href = this.github.GET_REPO_URL(repo);
      window.open(href, "_blank");
    },
  },
  mounted() {
    this.$store.dispatch("github/loadGithubProjects");
    this.$nextTick(() => {
      this.componentLoaded = true;
    });
  },
};
</script>
<style lang="scss" scoped>
#githubIconBtn:hover {
  color: var(--v-primary-base);
}
.card {
  border-radius: 25px;
  border-top: 2px solid var(--v-info-base);
  border-bottom: 2px solid var(--v-info-base);
}
</style>
